import React from 'react';
import { Save, Zap, Plus, Package } from 'lucide-react';

const ActionButtons = ({ 
  onSave, 
  onDeploy, 
  onNewSite, 
  onBidderManager,
  deploying = false,
  saveDisabled = false 
}) => {
  return (
    <div className="flex items-center gap-3">
      <button
        onClick={onSave}
        disabled={saveDisabled}
        className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors ${
          saveDisabled 
            ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
            : 'bg-green-600 text-white hover:bg-green-700'
        }`}
      >
        <Save size={16} />
        Save Changes
      </button>
      
      <button 
        onClick={onDeploy}
        disabled={deploying}
        className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors ${
          deploying 
            ? 'bg-gray-400 text-white cursor-not-allowed' 
            : 'bg-purple-600 text-white hover:bg-purple-700'
        }`}
      >
        <Zap size={16} />
        {deploying ? 'Deploying...' : 'Deploy'}
      </button>
      
      <button
        onClick={onNewSite}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
      >
        <Plus size={16} />
        New Site
      </button>
      
      {onBidderManager && (
        <button
          onClick={onBidderManager}
          className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors flex items-center gap-2"
        >
          <Package size={16} />
          Manage Bidders
        </button>
      )}
    </div>
  );
};

export default ActionButtons;